var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgIssueReport(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8 1.6a6.49628 6.49628 0 0 1 6.5 6.2v.3a6.487 6.487 0 0 1 -6.5 6.5 6.71029 6.71029 0 0 1 -2.8-.6l-.6-.3a4.61809 4.61809 0 0 1 -1.7.6 4.2214 4.2214 0 0 0 .5-1.6l-.5-.7a6.37207 6.37207 0 0 1 1-9 6.77315 6.77315 0 0 1 4.1-1.4m0-1.5a8.02352 8.02352 0 0 0 -8 8 7.681 7.681 0 0 0 1.8 5 6.49953 6.49953 0 0 1 -1.1 2.2.44193.44193 0 0 0 .3.7 6.61514 6.61514 0 0 0 3.5-.8 8.5251 8.5251 0 0 0 3.5.8 8.02352 8.02352 0 0 0 8-8 7.93842 7.93842 0 0 0 -8-7.9zm.9942 12h-2v-2h2zm0-3h-2v-5h2z' })));
}
export default SvgIssueReport;
